module.exports = function getResource(label, vars = []) {
    const resources = {
        error: 'Error',
        submissionError: 'Something went wrong while trying to process your submission. Please try again later.'
    };

    return resources[label];
};
